/* eslint-disable */
import { I18N_LOCALES } from '../../../Constants/I18n/I18n.constants';
import i18nValidateLangExists from '../ValidateLangExists/I18nValidateLangExists.support';

/**
 * The store to ue for translations
 * @export
 * @type {{ [lang: string]: object }}
 */
const cache = {};

const i18nStore = {
  add: (lang, key, rule) => {
    i18nValidateLangExists(lang, I18N_LOCALES);
    cache[lang] = {
      ...cache[lang],
      [key]: rule,
    };
  },
  get: () => {
    return cache;
  },
};

export default i18nStore;
